module.exports = __webpack_public_path__ + "media/images/icons/signal-19498d391d4d7f58fc55787022051e87.svg";